import { render, staticRenderFns } from "./WisdomDataShow.vue?vue&type=template&id=08ce1abe&"
import script from "./WisdomDataShow.vue?vue&type=script&lang=js&"
export * from "./WisdomDataShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports